module.exports = __webpack_public_path__ + "img/DUT4100_1-1.3fda6f91.png";